<template>
<div class="chapter">
<div class="inner_page">
<table>
<tbody>
<tr>
<td><p class="image1"><img alt="image1" src="images/box.jpg"/></p></td>
<td><h3 class="h3"><a id="page_6"></a><a id="acknow">Acknowledgements</a></h3></td>
</tr>
</tbody>
</table>
<p class="space">
</p><p class="noindent"><span class="dropcap"><span style="color:#585858 ">M</span></span>ANY FRIENDS AND COLLEAGUES have greatly assisted me in writing this book. Without them, it is certainly the case that this account detailing various stories behind missing aircrew lost on operations in various conflicts would have been rather more difficult to put together.</p>
<p class="indent">I should like to thank, in no particular order of merit: Winston Ramsey, Martin O’Brien, Steve Hall, Ian Hutton, Arnaud Gillet, Martin Mace, Colleen Ijuin, Simon Parry, Chris Goss, Richard Allen, Marjorie Allen, Dirk Decuypere, Gordon Leith, Gerald Oury, Philippa Hodgkiss, Gerry Burke, Cynrik De Decker, Jill Craig, Don Bryans, Dave Stubley, Norman Franks, Emmanuel Bril, Dick Walker, Barry Hammerton, Sue Raftree, Amanda Berry, Terry Thompson, Larry Hickey, Richard Lyon, Peter Cornwell, Ruth Bloom, Geoff Carless, Joe Bamford, Melvin Brownless, Jiri Rajlich, Janet Lacroix, Dale Wait, Robyn Saunders, David Hinton, Peter Hess, Fred Hagan, Ken Rimmel, Walter Mankelow, Air Cdre Mulder, Jan Gnodde, Dick van Polen and Lt Col Erik Rab.</p>
<p class="indent">I must also add a special thank you to Richard Lyon who allowed me to quote extensively from his own research material that he used in the Wikipedia page he has set up for his uncle, Russell Lyon.</p>
<p class="indent">An equally special thank you must also go to Michael Rank for allowing me to quote from his work regarding Flt Lt Hinton.</p>
<p class="indent">Once more I must also thank John Davies and his team at Grub Street, including Emer Hogan, Sophie Campbell and Sarah Driver. I look forward to working with you all again.</p>
<p class="indent">Last, but by no means least, a big thank you to Zoe who has again put up with my absence whilst I was shut away in my study to prepare this manuscript. Your support and understanding has, as ever, gone above and beyond the call of duty!</p>
<p class="indent">If I have overlooked anyone who has had an input to this book then I extend to them my sincerest apologies. It will have been an entirely unintentional oversight on my part. Thank you again one and all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknow.vue?a17338a8